import type { SearchResponse } from '../domain';

export async function searchProperties(params: URLSearchParams): Promise<SearchResponse> {
  const res = await fetch(`/search/api?${params.toString()}`, {
    headers: { Accept: 'application/json' },
  });
  if (res.redirected || res.headers.get('content-type')?.includes('text/html')) {
    window.location.reload();
    return Promise.reject(new Error('Authentication required'));
  }
  if (!res.ok) {
    throw new Error(`Search failed: ${res.status}`);
  }
  return res.json() as Promise<SearchResponse>;
}
